// TODO - this component is not valid according to the design system specification, a Spinner is preferred. However, often a Spinner is not appropriate such as when content is already a modal.

import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

type ButtonProgressIconProps = {
  color?: string;
};

const ButtonProgressIcon: React.FC<ButtonProgressIconProps> = ({ color = '#b0b7c3' }) => (
  <CircularProgress size="1rem" sx={{ marginLeft: 1.5, color }} />
);

export default ButtonProgressIcon;
